import { render, staticRenderFns } from "./TopicCreator.vue?vue&type=template&id=e8adb70a&scoped=true&"
import script from "./TopicCreator.vue?vue&type=script&lang=js&"
export * from "./TopicCreator.vue?vue&type=script&lang=js&"
import style0 from "./TopicCreator.vue?vue&type=style&index=0&id=e8adb70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8adb70a",
  null
  
)

export default component.exports